import React, {useState} from "react";
import {ImageUploader} from "../../../../components/ImageUploader";
import {Tooltip} from "../../../../designSystem/components/Tooltip";
import {ActionButton} from "../../../../designSystem/components/ActionButton";

export const LineCardEditor = ({
  title,
  content,
  text,
  link,
  image,
  onChangeTitle,
  onChangeContent,
  onChangeText,
  onChangeLink,
  onChangeImage,
}) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  return (
    <div>
      <ImageUploader
        isSquareCropper
        cropEnabled={false}
        handleUploadedImage={(url) => onChangeImage(url)}
        placeholder={"未上傳圖片"}
        uploadFolder="coverImage"
        uploadedImageUrl={image}
      />
      <div className="p-3">
        <input
          className="p-1 w-full font-bold text-lg"
          value={title}
          onChange={e => onChangeTitle(e.target.value)}
          placeholder="選單標題"
        />
        <textarea
          className="w-full p-2"
          rows={2}
          value={content}
          onChange={e => onChangeContent(e.target.value)}
          placeholder="內容"
        />
      </div>
      <div className="border-b border-gray-200" />
      { isEditMode ? (
        <div className="flex flex-row items-center gap-2 p-2">
          <div className="flex flex-1 border">
            <input
              className="w-full p-1"
              value={text}
              onChange={e => onChangeText(e.target.value)}
              placeholder="連結文字"
            />
          </div>
          <div className="flex flex-1 border">
            <input
              className="w-full p-1"
              value={link}
              onChange={e => onChangeLink(e.target.value)}
              placeholder="連結網址"
            />
          </div>
          <div className="flex">
            <ActionButton iconName="fa-save" onClick={() => setIsEditMode(false)} variant="outline" />
          </div>
        </div>
      ): (
        <div className="relative p-3 group">
          <div className="text-blue-900 text-center">
            <Tooltip content={"當使用者點這個連結時，會前往「" + link + "」"}>
              {text}
            </Tooltip>
          </div>
          <div
            className="absolute right-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition"
          >
            <ActionButton
              iconName="fa-pencil"
              onClick={() => setIsEditMode(true)}
              variant="ghost"
            />
          </div>
        </div>
      )}
    </div>
  )
}
